// 새 탭을 «처음부터» opener 없이 연다 — 게이트웨이와 다른 브라우저 프로세스로 띄우기 위해(2026-10-06).
// 🔴 opener 를 단 채 연 같은 오리진 창은 크롬이 같은 렌더러에 넣고, 나중에 opener=null 로 끊어도
//    갈라지지 않는다(무거운 시트가 게이트웨이까지 느리게 만든 원인).
// 🔴 window.open(url,'_blank','noopener') 를 쓰지 않는다 — 성공해도 null 이 돌아와 «팝업 차단» 과
//    구분이 안 된다. 대신 rel=noopener 링크를 최상위 문서에 만들어 누른다(사용자 클릭 처리 중이면
//    팝업 차단 대상이 아니다). noreferrer 는 넣지 않는다.
// 한계: 링크 방식은 차단 여부를 알 수 없다 — 차단되면 아무 일도 안 일어난다.
// 반환 = 링크를 눌렀으면 true, 예외면 false(호출부가 기본 동작으로 돌아가게).
export function openInNewProcess(url, doc = document) {
  let a = null;
  try {
    a = doc.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener';
    a.style.display = 'none';
    doc.body.appendChild(a);
    a.click();
    return true;
  } catch (e) {
    return false;
  } finally {
    if (a) { try { a.remove(); } catch (e) { /* */ } }   // 성공·실패 모두 링크를 남기지 않는다
  }
}
